<template>
  <div class="pdf-sign">
    <div class="pdf-sign__title">Подписание электронной подписью</div>
    <div v-if="signData">
      <SignFileNoModal
        v-model:signing="signing"
        v-model:loading="loadingCerts"
        :sign-data="signData"
        :auto-send-result="false"
        :debug="false"
        :action-before="actionBefore"
        :button-text="newStatusText"
        :file-name="fileName"
        :set-approve-file="setApproveFile"
        :show-files="showFiles"
        :signing-file-list="signingFileList"
        @error="showError"
        @success="successSign"
        @approve="setApproveFile"
        @un-approve="setUnApproveFiles"
      >
        <template #files>
          <BaseButton
            v-for="file in showFiles"
            :key="file.id"
            view="outlined"
            :class="[
              'SignFileNM__button-files',
              'SignFileNM__secondary',
              { 'SignFileNM__button-files__active': activeFile === file.id },
            ]"
            @click="setShowFile(file.id)"
          >
            <div v-if="!file.isApproved">
              <SvgImage value="pdf" style="width: 20px; height: 20px" />
              <span>Файл {{ file.id }}</span>
            </div>
            <div v-else>
              <Icon value="checkMark" :ui="{ icon: 'check-mark' }" />
              <span>Подписано</span>
            </div>
          </BaseButton>
        </template>
        <div v-if="Boolean(pdfUrl)">
          <div class="pdf-sign__preview-pdf">Предпросмотр PDF файла:</div>
          <iframe v-if="pdfUrl" :src="pdfUrl" class="pdf-sign__iframe" />
        </div>
        <!-- <div v-else-if="Boolean(xmlFile)">
          <div class="pdf-sign__preview-pdf">Предпросмотр XML файла:</div>
          <v-textarea
            v-model="xmlFile"
            rows="7"
            no-resize
            read-only
          />
        </div> -->
        <template #buttons>
          <BaseButton
            view="outlined"
            class="SignFileNM__button SignFileNM__secondary"
            @click="close"
          >
            Отменить
          </BaseButton>
        </template>
      </SignFileNoModal>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import BaseButton from '~packages/epk-front-shared/src/ui/Button/Button.vue';
import { SvgImage } from '~packages/epk-front-shared/src/ui/SvgImage';
import { Icon } from '~packages/epk-front-shared/ui';

import unProxy from '@/helpers/unProxy';

import { SignFileNoModal } from './ui';

const showAlert = ref(false);
const alertInfo = ref({});
const createAlert = info => {
  info.message = String(info.message).replace('Error: ', '');
  showAlert.value = true;
  alertInfo.value = info;
};

export default {
  name: 'FormSign',
  components: {
    SignFileNoModal,
    BaseButton,
    Icon,
    SvgImage,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    signingFile: {
      type: [Blob, Array],
      required: true,
    },
    signingFileType: {
      type: String,
      default: '',
    },
    signingFileList: {
      type: Array,
      default: () => [],
    },
    fileName: {
      type: String,
      default: 'file',
    },
    additionalFiles: { type: Array, default: () => [] },
    // editReports: {
    //   type: Array,
    //   default: () => [],
    // },
    newStatusText: { type: String, default: 'Подписать отчет' },
  },
  emits: ['close', 'save'],
  data() {
    return {
      pdfUrl: '',
      xmlFile: '',
      tabNumber: 0,
      activeFile: 1,

      certificateList: [],
      notification: {},
      blob: null,
      binary: null,
      signData: {
        base64: null,
        allPdfBase64: [],
        type: '',
        additionalFiles: [],
      },
      signature: {},
      signing: false,
      loadingCerts: false,
      idxCurrentPdf: 0,
      showFiles: [],
    };
  },
  computed: {
    isValidSignData: function () {
      return this.signData.base64 instanceof ArrayBuffer;
    },
    isDisabled: function () {
      return !this.isValidSignData;
    },
    loading() {
      return this.signing && this.loadingCerts;
    },
  },
  async mounted() {
    if (this.signingFileType) await this.loadBinary();
  },
  watch: {
    async signingFile() {
      await this.loadBinary();
    },
  },
  methods: {
    // chooseECP() {
    //   console.log('chooseECP');
    // },
    close() {
      this.$emit('close');
    },
    showError(e) {
      console.error(e.head + '\n' + e.text);
      createAlert({ type: 'error', message: e.head + '\n' + e.text });
    },
    successSign(signResult) {
      this.$emit('save', signResult);
    },
    async loadBinary() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      this.pdfUrl = '';
      // this.xmlFile = '';

      const signingFile = unProxy(this.signingFile);

      if (Array.isArray(signingFile)) {
        if (!signingFile.length) return;

        if (this.signingFileType === 'pdf') {
          this.pdfUrl = URL.createObjectURL(signingFile[this.idxCurrentPdf]);
        }

        const arrBuf = [];
        for (const file of signingFile) {
          const resBuf = await file.arrayBuffer();
          this.showFiles.push({
            id: arrBuf.length + 1,
            isApproved: false,
            file: resBuf,
          });
          arrBuf.push(resBuf);
        }

        this.signData = {
          base64: arrBuf[0],
          type: this.signingFileType,
          additionalFiles: this.additionalFiles,
        };
        return;
      }

      if (this.signingFileType === 'pdf') {
        this.pdfUrl = URL.createObjectURL(signingFile);
        // } else if (this.signingFileType === 'xml') {
        //   this.xmlFile = await fileToText(this.signingFile);
      }
      const arrBuf = await signingFile.arrayBuffer();
      this.signData = {
        base64: arrBuf,
        allPdfBase64: [],
        type: this.signingFileType,
        additionalFiles: this.additionalFiles,
      };
    },
    actionBefore() {
      // console.log('action before handler!');
    },
    setShowFile(num) {
      if (
        this.activeFile !== num &&
        this.signingFileType === 'pdf' &&
        this.idxCurrentPdf < this.signingFile.length - 1
      ) {
        this.activeFile = num;
        this.pdfUrl = URL.createObjectURL(this.signingFile[num - 1]);
      }
    },
    setApproveFile(id) {
      const approveFile = this.showFiles.find(file => file.id === id);
      if (approveFile) {
        approveFile.isApproved = true;
      }
    },
    setUnApproveFiles() {
      this.showFiles.forEach(file => (file.isApproved = false));
    },
  },
};
</script>

<style lang="scss" scoped src="./FormSign.scss" />
